import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../../api/commonAPI';

const TableCreatePage = () => {
    const [tableName, setTableName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();
    const { storeId } = useParams<{ storeId: string }>();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!tableName.trim()) {
            alert('테이블 이름을 입력해 주세요.');
            return;
        }

        if (!storeId) {
            alert('매장 ID를 찾을 수 없습니다. 다시 로그인해 주세요.');
            return;
        }

        setIsLoading(true);
        setError(null);

        try {
            await axiosInstance.post(`/api/stores/${storeId}/admin/tables`, {
                tableName
            });

            alert('새 테이블이 생성되었습니다.');
            navigate(`/admin/stores/${storeId}/tables`);
        } catch (err) {
            console.error('테이블 생성 실패:', err);
            setError('테이블을 생성하지 못했습니다. 입력값을 확인한 뒤 다시 시도해 주세요.');
            setIsLoading(false);
        }
    };

    return (
        <div style={containerStyle}>
            <h2>새 테이블 생성</h2>
            <p>키오스크에서 사용할 테이블 이름을 입력해 주세요.</p>

            <form onSubmit={handleSubmit} style={formStyle}>
                <div style={formGroupStyle}>
                    <label htmlFor="tableName" style={labelStyle}>테이블 이름</label>
                    <input
                        type="text"
                        id="tableName"
                        value={tableName}
                        onChange={(event) => setTableName(event.target.value)}
                        placeholder="예: 1번 테이블"
                        style={inputStyle}
                        required
                    />
                </div>

                {error && <p style={{ color: 'red' }}>{error}</p>}

                <button type="submit" disabled={isLoading} style={buttonStyle}>
                    {isLoading ? '생성 중...' : '테이블 생성'}
                </button>
                <button
                    type="button"
                    onClick={() => navigate(`/admin/stores/${storeId}/tables`)}
                    style={{ ...buttonStyle, backgroundColor: '#6c757d', marginLeft: '10px' }}
                >
                    취소
                </button>
            </form>
        </div>
    );
};

const containerStyle: React.CSSProperties = {
    padding: '30px',
    maxWidth: '600px',
    margin: '0 auto',
    fontFamily: 'sans-serif'
};

const formStyle: React.CSSProperties = {
    marginTop: '20px'
};

const formGroupStyle: React.CSSProperties = {
    marginBottom: '20px'
};

const labelStyle: React.CSSProperties = {
    display: 'block',
    marginBottom: '5px',
    fontWeight: 'bold'
};

const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc'
};

const buttonStyle: React.CSSProperties = {
    padding: '12px 24px',
    fontSize: '16px',
    cursor: 'pointer',
    color: 'white',
    backgroundColor: '#28a745',
    border: 'none',
    borderRadius: '5px'
};

export default TableCreatePage;
